import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../core/service/auth.service';
import { AlertsService } from '../../../../shared/service/alerts.service';

@Component({
  selector: 'app-forget-pw',
  templateUrl: './forget-pw.component.html',
  styleUrls: ['./forget-pw.component.scss']
})
export class ForgetPwComponent implements OnInit {
  form: UntypedFormGroup;
  password = ''
  confirmPassword = ''
  bundle = '';
  constructor(private router: Router, private api: AuthService, private alert: AlertsService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      if (params.bundle == undefined) {
        this.bundle = '';
        this.router.navigate(['/login'])
      }
      else {
        this.checkEncryptedString(params.bundle)
      }
    });
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = new UntypedFormGroup(
      {
        // email:new FormControl("",Validators.email),
        password: new UntypedFormControl("", Validators.required)
      })

    this.alert.detectFormChanges(this.form);
  }

  checkEncryptedString(bundle) { 
    this.api.checkEncryptedString({ str: bundle }).subscribe((res: any) => {
      const { success } = res;
      if (success) {
        this.bundle = bundle;
      }
      else {
        this.bundle = '';
      }
    }, (err) => this.alert.showToast(err.message, 'error'))
  }

  resetPassword() {
    var obj =
    {
      encrypt: this.bundle,
      password: this.form.value.password
    }

    this.api.setNewPassword(obj).subscribe((res: any) => {
      const { success, message } = res;
      if (success) {
        this.alert.showToast(message, 'success')
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 1000);
      }
      else {
        this.alert.showToast(message, 'error')
      }
    }, (err) => this.alert.showToast(err.message, 'error'))
  }

}
